<template>
  <div class="order-detail">
    <div class="title">
      <router-link to="/personalCenter/myOrder" target="_blank">我的订单</router-link>
      <span>> 订单详情</span>
    </div>
    <!-- 订单信息 -->
    <ul class="pay-box">
      <!-- 左侧信息及操作 -->
      <li class="lf">
        <!-- 订单号 -->
        <div class="order-txt">
          订单:
          <span>{{ detailObj.orderBatchNo }}</span>
        </div>
        <!-- 状态 -->
        <div class="h1">{{ orderStatusTxt }}</div>
        <!-- 倒计时 -->
        <div class="down-time" v-if="orderStatus == 1 && payStatus === 1">
          <img v-lazy="require('@/assets/img/down_time.png')" />
          <span>
            <count-down :target="detailObj.targetTime" :orderBatchId='orderBatchId' :on-end="onEndHandle" />
          </span>
        </div>
        <!-- 去付款 -->
        <div v-if="orderStatus == 1 && payStatus === 1 && isCanPay==1 && $store.state.allowPay == 1">
          <router-link :to="{path:'/payType',query: {id: detailObj.id, orderNo: detailObj.orderBatchNo}}" target="_blank">
            <el-button type="primary pay-btn">付款</el-button>
          </router-link>
        </div>
        <!-- 确认收货 -->
        <div v-if="orderStatus == 1 && (deliveryStatus == 5 || deliveryStatus == 6)" @click="completeOrder(detailObj.id)">
          <el-button :loading="loading" type="primary pay-btn">确认收货</el-button>
        </div>
        <!-- 取消订单，打印，导出 -->
        <div class="order-action">
          <div class="printing" v-if="orderStatus != 3">
            <i class="myicon iconfont icon-daochu"></i>
            <span class="com_link" @click="exportOrder()">导出</span>
          </div>
          <div class="printing" v-if="orderStatus != 3">
            <i class="myicon iconfont icon-dayin"></i>
            <router-link :to="{path:'/printOrder',query: {id: orderBatchId}}" target="_blank">
              <span>打印</span>
            </router-link>
          </div>
          <div class="printing" v-if="orderStatus == 1 && deliveryStatus == 3 && !detailObj.orderCancelApply">
            <i class="myicon iconfont icon-quxiaodingdan"></i>
            <span class="com_link" @click="cancelOrder()">取消订单</span>
          </div>
          <div class="printing" v-if="detailObj.orderCancelApply">
            <router-link :to="{path:'cancelDetail',query: {id: detailObj.orderCancelApply.id}}" target="_blank">
              <span class="canceled com_link">已申请取消</span>
            </router-link>
          </div>
        </div>
      </li>
      <!-- 右侧状态流程展示 -->
      <li class="lr">
        <div class="tip">
          {{tipText}}
        </div>
        <!-- 正常流程 -->
        <ul class="step" v-if="orderStatus != 3">
          <li v-for="(step, index) in orderStep" :key="index">
            <div class="step-cont">
              <div class="img">
                <img v-if="step.status == 1" v-lazy="step.imgActive" />
                <img v-else v-lazy="step.img" />
              </div>
              <div class="order-status">
                <p>{{ step.name }}</p>
                <!-- <p v-for="(ele,num) in step.time" :key="num">{{ele}}</p> -->
              </div>
            </div>
            <template v-if="index != 4">
              <div class="step-dot dot" v-if="step.status == 0">
                <span v-for="(dot, i) in 9" :key="i"></span>
              </div>
              <div class="active-dot dot" v-if="step.status == 1">
                <span v-for="(dot, i) in 9" :class="
                    i < 4
                      ? ['active']
                      : i == 4
                      ? ['max']
                      : orderStep[index + 1].status == 1
                      ? ['active']
                      : [' notActive']
                  " :key="i"></span>
              </div>
            </template>
          </li>
        </ul>
        <!-- 已取消 -->
        <ul class="cancel" v-else>
          <div class="img_box">
            <img v-lazy="require('@/assets/img/cancel.png')" />
          </div>
          <div class="step-txt">
            <span>提交审核</span>
            <span>系统处理</span>
            <span>完成</span>
          </div>
        </ul>
      </li>
    </ul>
    <!-- 用户信息 -->
    <ul class="consignee">
      <li class="br_right consignee-list">
        <p>收货人信息</p>
        <div class="consig-distr">
          <div class="consignee-name">
            <span class="lable">收货人：</span>
            <b>{{ detailObj.consignee }}</b>
          </div>
          <div class="address">
            <span class="lable">地址：</span>
            <div class="address-box">
              {{ detailObj.deliveryProName }}{{ detailObj.deliveryCityName
              }}{{ detailObj.deliveryDisName }}{{detailObj.deliveryTownName}}{{ detailObj.deliveryAddr }}
            </div>
          </div>
          <div class="phone">
            <span class="lable">手机号码:</span>
            <b v-if="detailObj.consigneeTel">{{ String(detailObj.consigneeTel) | phoneInter }}</b>
          </div>
        </div>
      </li>
      <li class="br_right consignee-list">
        <p>配送信息</p>
        <div class="consig-distr">
          <!-- <div>
            <span class="lable">配送方式：</span>
            <b>{{ detailObj.deliveryWay | filterDeliveryWayType }}</b>
            <b v-if="detailObj.freightFee != undefined">￥{{ detailObj.freightFee | priceValue}}</b>
          </div> -->
          <div v-if="$store.state.openOrderServiceFee == 1 && !isShopView">
            <span class="lable">物流服务：</span>
            <b>{{ detailObj.logisticsType | filterLogisticsType(isShopView) }}</b>
            <b v-if="detailObj.serviceFee != undefined">￥{{ parseInt(detailObj.serviceFee) | priceValue}}</b>
          </div>
          <div>
            <span class="lable">期望送货日期:</span>
            <b>{{ detailObj.goodsWishSendTime }}</b>
          </div>
        </div>
      </li>
      <li class="consignee-list">
        <p>付款信息</p>
        <ul class="payment">
          <li>
            <span class="lable">付款方式：</span>
            <b>{{payType}}</b>
          </li>
          <li>
            <span class="lable">订单总金额:</span>
            <b v-if="detailObj.orderTotalFee != undefined">￥{{ parseInt(detailObj.orderTotalFee) | priceValue}}</b>
          </li>
        </ul>
      </li>
    </ul>
    <!-- 订单商品列表 -->
    <div class="order-table">
      <div class="table">
        <!-- 表头 -->
        <div class="head">
          <p class="goods">商品</p>
          <p>单价</p>
          <p>商品数量</p>
          <p>小计</p>
          <p>备注</p>
          <p>发货状态</p>
          <p>操作</p>
        </div>
        <!-- 商品列表 -->
        <ul class="table-list">
          <li v-for="(item, index) in orderGoodsBrandList" :key="index" :class="index != 0 ? 'br_top' : ''">
            <div class="first_name">
              {{item.goodsBrandName}}
            </div>
            <div class="goods-list" v-for="(goods, i) in item.goodsMixList" :key="i">
              <div class="goods">
                <div class="img">
                  <router-link :to="goods.goodsPath" target="_blank">
                    <img v-lazy="goods.mainPreviewImageFilePath" />
                  </router-link>
                </div>
                <div class="goods-intr">
                  <router-link :to="goods.goodsPath" target="_blank">
                    <p class="goods-name com_link">
                      商品名称:{{ goods.goodsName+" "+goods.goodsMixName }}
                    </p>
                    <p class="specs com_link">
                      商品货号 :{{ goods.goodsMixNo }}
                    </p>
                    <p class="specs com_link">
                      商品规格:
                      <span>{{goods.attr1ContentName}}</span>
                      <span>{{goods.attr2ContentName?'+'+goods.attr2ContentName:""}}</span>
                      <span>{{goods.attr3ContentName?'+'+goods.attr3ContentName:""}}</span>
                      <span>{{goods.attr4ContentName?'+'+goods.attr4ContentName:""}}</span>
                    </p>
                    <p class="specs com_link">
                      商品编号:{{ goods.goodsMixSerNo }}
                    </p>
                  </router-link>
                </div>
              </div>
              <div class="item">
                <span>￥{{ goods.salePrice | priceValue }}</span>
              </div>
              <div class="item">
                <span>{{ goods.buyCount }}</span>
              </div>
              <div class="item">
                <span>￥{{ goods.salePrice*goods.buyCount | priceValue }}</span>
              </div>
              <div class="item word_break">{{ goods.remark }}</div>
              <div class="item">
                <span>{{ goods.deliveryStatus | filStatus }}</span>
              </div>
              <div class="item">
                <span class="com_link" @click="buyAgain(goods)">再次购买</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 订单金额信息 -->
      <div class="order-total">
        <div class="total-box">
          <div class="total">
            <span>商品总金额:</span>
            <b v-if="detailObj.originalFee != undefined">￥{{ parseInt(detailObj.originalFee) | priceValue}}</b>
          </div>
          <div class="total flex" v-if="$store.state.openOrderServiceFee == 1 && !isShopView">
            <div class="dis_box">
              <span>服务费:</span>
              <el-popover placement="left" width="200" trigger="hover" v-if="serviceFeeList.length">
                <div>
                  <p :style="{'fontSize':'12px'}" v-for="(v,i) in serviceFeeList" :key="i">
                    <span v-for="(j,k) in v" :key="k">{{k+'：'+j}}</span>
                  </p>
                </div>
                <span slot="reference" class="remake">?</span>
              </el-popover>
            </div>
            <b>￥{{ detailObj.totalServiceFee | priceValue}}</b>
          </div>
          <div class="total flex" v-if="detailObj.orderDisCountTotalFee">
            <div class="dis_box">
              <span>订单优惠:</span>
              <el-popover placement="left" width="200" trigger="hover">
                <div>
                  <p :style="{'fontSize':'12px'}" v-for="(v,i) in detailObj.orderDisCountList" :key="i">
                    <span v-for="(j,k) in v" :key="k">{{k+'：'+j}}</span>
                  </p>
                </div>
                <span slot="reference" class="remake">?</span>
              </el-popover>
            </div>
            <b>￥-{{ detailObj.orderDisCountTotalFee | priceValue}}</b>
          </div>
          <div class="total tip">
            <span>订单总金额:</span>
            <b v-if="detailObj.orderTotalFee != undefined">￥{{ parseInt(detailObj.orderTotalFee) | priceValue}}</b>
          </div>
        </div>
      </div>
    </div>
    <!--取消订单-->
    <cancel-order ref="cancel" @refresh="refresh" :GetCancelOrder="GetCancelOrder" :CancelOrder="CancelOrder"></cancel-order>
  </div>
</template>                                   
<script>
const orderStep = [
  {
    name: "提交订单",
    time: [],
    status: 0,
    img: require("@/assets/img/sa-2.png"),
    imgActive: require("@/assets/img/sa-1.png"),
  },
  {
    name: "付款成功",
    time: [],
    status: 0,
    img: require("@/assets/img/sa-4.png"),
    imgActive: require("@/assets/img/sa-3.png"),
  },
  {
    name: "商品出库",
    time: [],
    status: 0,
    img: require("@/assets/img/sa-6.png"),
    imgActive: require("@/assets/img/sa-5.png"),
  },
  {
    name: "等待收货",
    time: [],
    status: 0,
    img: require("@/assets/img/sa-8.png"),
    imgActive: require("@/assets/img/sa-7.png"),
  },
  {
    name: "订单完成",
    time: [],
    status: 0,
    img: require("@/assets/img/sa-10.png"),
    imgActive: require("@/assets/img/sa-9.png"),
  },
];
const deliveryDayType = {
  1: "仅工作日",
  2: "仅双休日节假日送货 ",
  3: "工作日双休日_节假日均可送货 ",
};
const statusList = {
  1: "待发货",
  2: "已发货",
  3: "货到城市",
  4: "已签收",
};
const logisticsTypeMap1 = {
  1: "多比物流+自提",
  2: "多比物流+多比送装",
  3: "客户指定物流",
  4: "指定物流+多比送装",
};
const logisticsTypeMap2 = {
  1: "商家物流+自提",
  2: "商家物流+商家送装",
  3: "客户指定物流",
  4: "指定物流+商家送装",
};
const deliveryWayMap = {
  1: "普通配送_家装物流",
};
import CancelOrder from "@/pages/publicView/personalCenter/components/cancelOrder_view.vue";
import CountDown from "@/components/CountDown";
export default {
  metaInfo: { title: "订单详情 - 个人中心" },
  props: {
    isShopView: {
      type: Boolean,
      default: false,
    },
    GetOrderDetail: {
      type: Function,
      default: () => {},
    },
    OverTimecancelOrder: {
      type: Function,
      default: () => {},
    },
    ExportExcel: {
      type: Function,
      default: () => {},
    },
    CompleteOrderBatch: {
      type: Function,
      default: () => {},
    },
    GetCancelOrder: {
      type: Function,
      default: () => {},
    },
    CancelOrder: {
      type: Function,
      default: () => {},
    },
    AddShopCart: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      orderStep,
      deliveryDayType,
      orderStatusTxt: "",
      tipText: "",
      orderBatchId: null,
      orderStatus: null, //当前订单状态
      payStatus: null, //当前订单支付状态
      deliveryStatus: null, //当前订单发货状态
      isCanPay: null, //当前订单支付权限
      detailObj: {},
      serviceFeeList: [], //服务k v
      orderGoodsBrandList: [], //订单商家列表
      loading: false,
    };
  },
  components: {
    CountDown,
    CancelOrder,
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.orderBatchId = this.$route.query.id;
      let params = { orderBatchId: this.orderBatchId };
      this.GetOrderDetail(params).then((res) => {
        // console.log("获取订单详情", res);
        this.detailObj = res.data[0];
        this.serviceFeeList = res.data[0].serviceFeeList;

        let startTime = this.detailObj.createTime;
        let payExpire = this.detailObj.payExpire * 1000;
        this.detailObj.targetTime = Date.parse(startTime.replace(/-/g, "/"));
        this.detailObj.targetTime += payExpire;

        this.orderGoodsBrandList = this.detailObj.orderGoodsBrandList;
        this.orderGoodsBrandList.forEach((v) => {
          v.goodsMixList.forEach((count) => {
            this.$set(count, "goodsPath", ""); //商品详情地址
            if (this.isShopView) {
              // 不控价店铺空间不需要
              count.goodsPath = `/sysGoodsDetail/-1/${count.goodsCategorySerNo}/${count.goodsMixSerNo}.html`;
            } else {
              count.goodsPath = `/goodsDetails/${count.goodsMixSerNo}.html`;
            }
          });
        });

        this.setStepStatus(this.detailObj);
      });
    },
    onEndHandle(id) {
      // console.log(id);
      this.OverTimecancelOrder({ orderBatchId: id }).then((res) => {
        // console.log(res);
        this.getDetail();
      });
    },
    cancelOrder() {
      this.$refs.cancel.showModal(this.orderBatchId);
    },
    exportOrder() {
      // 避免被拦截，先跳转到空白页面
      let tempPage = window.open("", "_blank");
      this.ExportExcel({ orderBatchId: this.orderBatchId }).then((res) => {
        // console.log('导出订单',res);
        let downloadFile = res.data[0];
        tempPage.location = downloadFile;
      });
    },
    completeOrder(id) {
      this.$confirm("确认已收货吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.CompleteOrderBatch({ orderBatchId: id })
            .then((res) => {
              // console.log('确认收货',res);
              this.loading = false;
              this.getDetail();
            })
            .catch((err) => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //设置右侧状态值
    setStepStatus(item) {
      // console.log(item);
      this.orderStatus = item.orderStatus;
      this.payStatus = item.payStatus;
      this.deliveryStatus = item.deliveryStatus;
      this.isCanPay = item.isCanPay;
      // this.orderStatus = 1
      // this.payStatus = 3
      // this.deliveryStatus = 4
      if (this.orderStatus === 1) {
        if (this.payStatus === 1 || this.payStatus === 2) {
          this.orderStatusTxt = "待付款";
          this.tipText =
            "请在3天内完成支付，3天内（从下单日算起）如果还未付款到账，系统将自动取消订单";
          this.orderStep.forEach((v, i) => {
            if (i == 0) {
              v.status = 1;
              // v.time = [];
              // v.time = this.detailObj.createTime.split(" ");
            }
          });
          // 部分付款不要提示语
          if (this.payStatus === 2) {
            this.tipText = "";
          }
        } else {
          // 付全款了
          if (this.deliveryStatus == 3) {
            this.orderStatusTxt = "待发货";
            this.tipText = "请您耐心等待，商家正在加紧备货！";
            this.orderStep.forEach((v, i) => {
              if (i <= 1) {
                v.status = 1;
              }
            });
          }
          if (this.deliveryStatus == 4 || this.deliveryStatus == 7) {
            this.orderStatusTxt = "发货中";
            this.tipText = "请您耐心等待，货物已进入物流运输途中!";
            this.orderStep.forEach((v, i) => {
              if (i <= 2) {
                v.status = 1;
              }
            });
          }
          if (this.deliveryStatus == 5) {
            this.orderStatusTxt = "待收货";
            this.tipText = "请您耐心等待，师傅们已快马加鞭准备为您送货！";
            this.orderStep.forEach((v, i) => {
              if (i <= 3) {
                v.status = 1;
              }
            });
          }
          if (this.deliveryStatus == 6) {
            this.orderStatusTxt = "已收货";
            this.tipText = "您的商品已收货，欢迎您再次惠顾！";
            this.orderStep.forEach((v, i) => {
              if (i <= 4) {
                v.status = 1;
              }
            });
          }
        }
      } else if (this.orderStatus === 2) {
        this.orderStatusTxt = "已完成";
        this.tipText = "您的订单已完成，欢迎您再次惠顾！";
        this.orderStep.forEach((v, i) => {
          if (i <= 4) {
            v.status = 1;
          }
        });
      } else if (this.orderStatus === 3) {
        this.orderStatusTxt = "已取消";
        this.tipText = "您的订单拦截成功，所有付款项将原路退回到您的支付账户";
      } else {
        this.orderStatusTxt = "该订单状态异常";
      }
    },
    refresh() {
      this.getDetail();
    },
    // 再次购买进购物车
    buyAgain(goods) {
      // console.log(goods);
      let params = {
        regionCode: localStorage.getItem("_regionCode"),
        goodsMixId: goods.goodsMixId,
        goodsMixCount: goods.buyCount,
        spaceId: goods.spaceId,
      };
      this.AddShopCart(params).then((res) => {
        // console.log("加入购物车", res);
        let newUrl = this.$router.resolve(
          this.isShopView ? "/sysShopCart" : "/shopCart"
        );
        window.open(newUrl.href, "_self");
      });
    },
  },
  computed: {
    payType() {
      let typeStr = "";
      if (!this.detailObj.payList) {
        return;
      }
      let typeArr = [];
      this.detailObj.payList.forEach((v) => {
        if (typeArr.indexOf(v.payWayStr) == -1) {
          typeArr.push(v.payWayStr);
        }
      });
      typeStr = typeArr.join("，");
      return typeStr;
    },
  },
  filters: {
    deliveryDate(type, time) {
      return deliveryDayType[type] + "【" + time + "】";
    },
    filStatus(val) {
      return statusList[val];
    },
    filterLogisticsType(type, isShopView) {
      if (isShopView) {
        return logisticsTypeMap2[type];
      }
      return logisticsTypeMap1[type];
    },
    filterDeliveryWayType(type) {
      return deliveryWayMap[type];
    },
  },
};
</script>

<style lang="less" scoped>
.order-detail {
  margin: 83px 0px 32px;
  width: 100% !important;
  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 31px;
    background: rgba(244, 244, 244, 1);
    a {
      color: #1a1a1a;
    }
  }
  .pay-box {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 294px;
    border: 1px solid rgba(243, 243, 243, 1);
    overflow: hidden;
    .lf {
      border-right: 1px solid rgba(243, 243, 243, 1);
      width: 310px;

      height: 294px;
      display: flex;
      box-sizing: border-box;
      padding: 0px 43px;
      flex-direction: column;
      align-items: center;
      position: relative;
      .order-txt {
        font-size: 12px;
        margin: 30px 0px 22px;
        color: rgba(151, 151, 151, 1);
      }
      .h1 {
        font-size: 20px;
        font-weight: 800;
        color: rgba(255, 169, 32, 1);
      }
      .down-time {
        margin: 7px 0px 0px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(143, 143, 143, 1);
        img {
          width: 15px;
          height: 16px;
          margin-right: 11px;
          vertical-align: sub;
        }
      }
      .pay-btn {
        width: 102px;
        height: 24px;
        box-sizing: border-box;
        padding: 0;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        margin-top: 25px;
      }
      .order-action {
        width: 100%;
        box-sizing: border-box;
        padding: 0 43px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        position: absolute;
        bottom: 30px;
        left: 0;
        .printing {
          img {
            width: 15px;
            height: 16px;
            margin-right: 7px;
            vertical-align: bottom;
          }
          span {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(25, 25, 25, 1);
          }
          .myicon {
            color: #a3a3a3;
            font-size: 14px;
            padding-right: 5px;
          }
          .canceled {
            font-weight: bold;
            color: #e4393c;
          }
        }
      }
    }
    .lr {
      padding: 30px 0px 0px 35px;
      box-sizing: border-box;
      width: 970px;
      .tip {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 69px;
      }
      .step {
        display: flex;
        li {
          display: flex;
          .img {
            text-align: center;
            margin-bottom: 15px;
            img {
              width: 45px;
              height: 43px;
            }
          }
          .dot {
            height: 8px;
            box-sizing: border-box;
            margin: 18px 9px;
            justify-content: center;
            display: flex;
            align-items: center;
            span {
              width: 5px;
              cursor: pointer;
              height: 5px;
              margin: 0px 3px;
              border-radius: 50%;
              display: inline-block;
              background: #a9a9a9;
            }
          }

          .active-dot {
            .max {
              width: 8px;
              height: 8px;
              background: #ffa91f;
            }
            .active {
              background: #ffa91f;
            }
            .notActive {
              background: #a9a9a9;
            }
          }
          .order-status {
            text-align: center;
            p {
              margin-bottom: 10px;
              color: #000;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .consignee {
    width: 100%;
    height: 294px;
    border: 1px solid rgba(243, 243, 243, 1);
    box-sizing: border-box;
    display: flex;
    .br_right {
      border-right: 1px solid rgba(243, 243, 243, 1);
    }
    .consignee-list {
      padding-top: 22px;
      box-sizing: border-box;
      margin: 22px 0px 0px 34px;
      flex: 1;
      height: 250px;
      font-size: 14px;
      .consig-distr,
      .payment {
        line-height: 24px;
      }
      p {
        margin-bottom: 30px;
      }
      .lable {
        // margin-right: 10px;
        display: inline-block;
        // width: 120px;
        padding-right: 20px;
      }
      .address {
        display: flex;
      }
      .payment {
        .pay_fee {
          position: relative;
          .remake {
            position: absolute;
            top: 50%;
            right: -20px;
            margin-top: -7px;
            width: 12px;
            height: 12px;
            line-height: 12px;
            padding: 1px;
            background-color: #b3b5be;
            border-radius: 50%;
            text-align: center;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .cancel {
    display: flex;
    flex-wrap: wrap;
    .img_box {
      width: 100%;
    }
    .step-txt {
      width: 100%;
      display: flex;
      box-sizing: border-box;
      margin: 15px 0px;
      span {
        text-align: center;
        font-size: 14px;
      }
      span:nth-child(1) {
        flex: 1.2;
      }
      span:nth-child(2) {
        flex: 5;
        text-indent: 8px;
      }
      span:nth-child(3) {
        flex: 1.2;
        text-indent: 12px;
      }
    }
  }
  .order-table {
    .shop-name {
      height: 45px;
      line-height: 45px;
      margin-left: 4px;
      color: rgba(25, 25, 25, 1);
      font-size: 16px;
    }
    .table {
      width: 100%;
      // height: 294px;
      border: 1px solid rgba(243, 243, 243, 1);
      font-size: 14px;
      box-sizing: border-box;
      .head {
        height: 30px;
        background: rgba(243, 243, 243, 1);
        border: 1px solid rgba(243, 243, 243, 1);
        border-bottom: none;
        display: flex;
        p {
          line-height: 30px;
          text-align: center;
          flex: 1;
        }
        .goods {
          flex: 3;
        }
      }
      .table-list {
        .br_top {
          border-top: 1px solid rgba(243, 243, 243, 1);
        }
        li {
          padding: 22px 0px;
          box-sizing: border-box;
          .first_name {
            padding: 0 0 10px 24px;
            color: #1a1a1a;
            font-weight: bold;
          }
          .goods-list {
            display: flex;
            margin-bottom: 15px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .goods {
            display: flex;
            flex: 3;
            .img {
              cursor: pointer;
              margin: 0px 27px 0px 24px;
              img {
                width: 100px;
                height: 100px;
                border: 1px solid #babbbb;
              }
            }
            .goods-intr {
              box-sizing: border-box;
              cursor: pointer;
              font-size: 12px;
              .goods-name {
                margin-bottom: 10px;
                color: #000000;
              }
              .specs {
                color: #a9a9a9;
                margin-bottom: 5px;
              }
            }
          }
          .item {
            flex: 1;
            text-align: center;
          }
        }
      }
    }
  }
}

.order-total {
  display: flex;
  border: 1px solid #f3f3f3;
  border-top: none;
  align-items: center;
  box-sizing: border-box;
  // width: 100%;
  justify-content: flex-end;
  .total-box {
    font-size: 14px;
    margin-right: 30px;
    // width: 200px;
    box-sizing: border-box;
    padding-top: 30px;
    padding-bottom: 20px;
    .total {
      line-height: 24px;
      span {
        display: inline-block;
        width: 100px;
      }

      .w_37 {
        width: 37px;
      }
      .w_70 {
        width: 70px;
      }
      b {
        width: 130px;
        display: inline-block;
        text-align: right;
      }
      .dis_box {
        position: relative;
        width: 100px;
        span {
          width: auto;
        }
        .remake {
          position: absolute;
          top: 50%;
          right: 10px;
          margin-top: -7px;
          width: 12px;
          height: 12px;
          line-height: 12px;
          padding: 1px;
          background-color: #b3b5be;
          border-radius: 50%;
          font-size: 12px;
          text-align: center;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .tip {
      color: red;

      b {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>